import { Icon } from "@albelli/arc-3-react/lib/Icon";
import { Panel } from "@albelli/arc-3-react/lib/Panel/Panel";
import classnames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import styles from "./PhotoOrganizer.module.css";

export const PhotoOrganizer = ({ className }) => {
  const menu = useSelector(state => state.menu);
  const photoOrganizerUrl = menu && menu.items && menu.items.routes && menu.items.routes.PhotoOrganizer;
  if (!photoOrganizerUrl) {
    return null;
  }

  const classes = classnames(className, styles.photoOrganizer);
  return (
    <div className={classes}>
      <Panel className="arc3-full-width">
        <div className={styles.title}>
          <Icon name="minnebanken" size="extra-small" className={styles.icon} />
          <h3 className="arc3-no-margin">
            <FormattedMessage id="photoOrganizer.title" defaultMessage="My pictures" />
          </h3>
        </div>

        <p className="arc3-no-margin--bottom">
          <FormattedMessage
            id="photoOrganizer.message"
            defaultMessage="The memory bank gives you safe and free storage of your photos. Here you will find all your saved photos and albums and you can share them with friends and family."
          />
        </p>
      </Panel>
      <a href={photoOrganizerUrl} className="link--bold link--bold-decoration-color-cyan arc3-margin">
        <FormattedMessage id="photoOrganizer.link" defaultMessage="See My Pictures" />
      </a>
    </div>
  );
};
